import React from "react";
import "../../css/CRUDModal.css";

const ProductDetailsModal = ({ show, handleClose, productDetail }) => {
  const handleBack = () => {
    handleClose();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "900px",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                }}
              >
                <h5 className="modal-title main-title">{`Product Details`}</h5>
              </div>
              <form>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "24px",
                  }}
                >
                  {productDetail && productDetail?.length > 0 ? (
                    <div className="table-container" style={{ width: "100%" }}>
                      <div className="table-wrapper">
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th style={{ textAlign: "center" }}>Quantity</th>
                              <th>Value</th>
                              <th>Category</th>
                              <th>Description</th>
                              <th>SKU</th>
                              <th>HSN/SAC Code</th>
                              <th>GST (%)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {productDetail?.map((item, index) => (
                              <tr key={index}>
                                <td>{item.productName || "-"}</td>
                                <td style={{ textAlign: "center" }}>
                                  {item.productQuantity || "-"}
                                </td>
                                <td>
                                  {item.productValue
                                    ? Number(item.productValue).toFixed(2)
                                    : "-"}
                                </td>
                                <td>{item.productCategory || "-"}</td>
                                <td>{item.productDescription || "-"}</td>
                                <td>{item.productSku || "-"}</td>
                                <td>{item.productHsnsac || "-"}</td>
                                <td>{item.productTaxper || "-"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#888",
                        fontStyle: "italic",
                      }}
                    >
                      No wallet details available.
                    </div>
                  )}
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-back"
                    onClick={handleBack}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductDetailsModal;
